import clsx from 'clsx'

import styled from 'styled-components'

export type ContentLoaderProps = {
  className?: string
  loaderSize?: boolean
}

const Content = styled.div<ContentLoaderProps>`
  flex-direction: column;
  width: ${(props) => (props.loaderSize ? '7.5rem' : '100%')};
  height: ${(props) => (props.loaderSize ? '2rem' : '100%')};
`
const Shine = styled.div`
  animation: shine 2500ms infinite linear;
  background-image: linear-gradient(
    90deg,
    var(--gray-200) 0,
    var(--gray-100) 45%,
    var(--gray-200) 90%
  );
  background-size: 200%;

  @keyframes shine {
    0% {
      background-position: 100%;
    }
    40% {
      background-position: -100%;
    }
    100% {
      background-position: -300%;
    }
  }
`

const ContentLoader = ({ className, loaderSize = false }: ContentLoaderProps) => {
  return (
    <Content
      data-test='content-loader'
      className={clsx('_d-flex _justify-content-center _align-items-center', className)}
      loaderSize={loaderSize}>
      <Shine
        data-test='shine'
        className='_d-block _h-full _w-full _bg-gray-200 _rounded _border-lg'
      />
    </Content>
  )
}

export default ContentLoader
